// hooks/useKeyScrollLock.js
import { useCallback, useEffect } from "react";

/**
 * When enabled == true, this hook disables scrolling based on keys
 *      This hook itself focuses blocking keys like page up, page down, space, etc...
 */
export default function useKeyScrollLock(enabled) {
  /**
   * Key press handler
   * On any key pressed ("keydown"), this handler is called by the eventlistener
   * If the key pressed is one of the ones in the set,
   * We will disable its default behavior, i.e. scrolling.
   */
  const onKey = useCallback(
    (e) => {
      if (!enabled) return;
      /**
       * In case the key pressed is in an editable container, we do not block it
       *    This is not really necessay cuz this only runs when the dropdown menu is toggled
       *    If it is toggled, a user shouldn't be typing in any container anyways.
       *    And when the user clicks anywhere outside the dropdown menu, it will close the menu
       *        This will also re-enable key scrolling capabilities
       */
      const t = e.target;
      const isEditable =
        t?.isContentEditable ||
        t?.tagName === "INPUT" ||
        t?.tagName === "TEXTAREA" ||
        t?.tagName === "SELECT";
      if (isEditable) return;

      const keys = new Set([
        " ",
        "Spacebar",
        "PageUp",
        "PageDown",
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
      ]);
      if (keys.has(e.key)) e.preventDefault();
    },
    [enabled]
  );

  /**
   * This useEffect runs only after react has commited the DOM
   * It also runs when "enabled", or onKrey function changes.
   */
  useEffect(() => {
    if (!enabled) return;
    window.addEventListener("keydown", onKey, { capture: true });
    return () =>
      window.removeEventListener("keydown", onKey, { capture: true });
  }, [enabled, onKey]);
}
